/* BIOSx — Pregnancy landing page behaviour.
   Loaded once per page (duplicate <script src> tags are de-duplicated by the browser).
   Safe to re-run: every routine is idempotent and guards on data-attributes. */
(function () {
  'use strict';
  if (window.__bxpLoaded) return;
  window.__bxpLoaded = true;

  /* ---------------- count-up on the big percentages only ---------------- */
  function countSetup(root) {
    var nums = [].slice.call((root || document).querySelectorAll('.bxp .cnt'));
    if (!nums.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function countUp(el) {
      var t = parseInt(el.getAttribute('data-target'), 10) || 0;
      if (reduce) { el.textContent = t; return; }
      var s = null, d = 1400;
      function step(ts) {
        if (!s) s = ts;
        var p = Math.min((ts - s) / d, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(t * e);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !e.target.dataset.done) {
            e.target.dataset.done = '1';
            countUp(e.target);
          }
        });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { if (!n.dataset.done) io.observe(n); });
    } else {
      nums.forEach(countUp);
    }
  }

  /* ---------------- trust strip marquee ---------------- */
  function marqueeSetup(root) {
    var rows = [].slice.call((root || document).querySelectorAll('.bxp .trow'));
    rows.forEach(function (trow) {
      if (trow.dataset.dup) return;
      var trust = trow.closest('.trust');
      if (!trust) return;
      var natural = 0;
      [].slice.call(trow.children).forEach(function (c) { natural += c.offsetWidth + 28; });
      if (natural > trow.parentNode.clientWidth) {
        trow.innerHTML += trow.innerHTML;
        trow.dataset.dup = '1';
        trust.classList.add('scroll');
        trust.style.setProperty('--mq', Math.round(natural / 34) + 's');
      }
    });
  }

  /* ---------------- variant-aware CTA ---------------- */
  var state = null, SIZES = [], VARIANTS = {}, PRODUCT_NAME = 'Departures', MMHG = '', PRICE = '';

  function readData() {
    var tag = document.getElementById('bxp-variant-data');
    if (!tag) return false;
    var d;
    try { d = JSON.parse(tag.textContent); } catch (e) { return false; }
    SIZES = d.sizes || [];
    VARIANTS = d.variants || {};
    PRODUCT_NAME = d.product_name || 'Departures';
    MMHG = d.mmhg || '';
    PRICE = d.price || '';
    state = { handle: d.default_handle, colour: d.default_colour, size: d.default_size || SIZES[0] };
    return true;
  }

  function url() {
    if (!state) return '#';
    var i = SIZES.indexOf(state.size); if (i < 0) i = 0;
    var v = (VARIANTS[state.handle] || [])[i];
    return '/products/' + state.handle + (v ? ('?variant=' + v) : '');
  }

  function sync() {
    if (!state) return;
    var cn = document.getElementById('bxp-colName'), sn2 = document.getElementById('bxp-sizeName');
    if (cn) cn.textContent = state.colour;
    if (sn2) sn2.textContent = String(state.size).replace(' - ', ' – ');
    var u = url();
    [].slice.call(document.querySelectorAll('.bxp a.cta')).forEach(function (a) {
      a.setAttribute('href', u);
    });
    var sn = document.getElementById('bxp-stickyName'),
        sm = document.getElementById('bxp-stickyMeta'),
        sc = document.getElementById('bxp-stickyCta');
    if (sn) sn.textContent = PRODUCT_NAME + ' · ' + state.colour;
    if (sm) sm.textContent = [MMHG, String(state.size).replace(' - ', ' – '), PRICE]
      .filter(Boolean).join(' · ');
    if (sc) sc.setAttribute('href', u);
  }

  function pickerSetup() {
    if (!readData()) return;
    var sws = document.getElementById('bxp-swatches');
    if (sws && !sws.dataset.bound) {
      sws.dataset.bound = '1';
      sws.addEventListener('click', function (e) {
        var t = e.target.closest('.sw'); if (!t) return;
        sws.querySelectorAll('.sw').forEach(function (s) {
          s.classList.remove('on'); s.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('on'); t.setAttribute('aria-pressed', 'true');
        state.colour = t.dataset.col; state.handle = t.dataset.handle; sync();
      });
    }
    var szs = document.getElementById('bxp-sizes');
    if (szs && !szs.dataset.bound) {
      szs.dataset.bound = '1';
      szs.addEventListener('click', function (e) {
        var t = e.target.closest('.size'); if (!t) return;
        szs.querySelectorAll('.size').forEach(function (s) {
          s.classList.remove('on'); s.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('on'); t.setAttribute('aria-pressed', 'true');
        state.size = t.dataset.size; sync();
      });
    }
    sync();
  }

  /* ---------------- size / care drawer ---------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var lastFocus = null;

  function drawerEls() {
    return { ovl: document.getElementById('bxp-ovl'), dr: document.getElementById('bxp-drawer') };
  }
  function openDrawer(trigger) {
    var e = drawerEls(); if (!e.dr) return;
    lastFocus = trigger || document.activeElement;
    if (e.ovl) e.ovl.classList.add('on');
    e.dr.classList.add('on');
    document.body.style.overflow = 'hidden';
    e.dr.setAttribute('tabindex', '-1');
    var f = e.dr.querySelectorAll(FOCUSABLE);
    (f[0] || e.dr).focus();
  }
  function closeDrawer() {
    var e = drawerEls(); if (!e.dr) return;
    if (e.ovl) e.ovl.classList.remove('on');
    e.dr.classList.remove('on');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function drawerSetup(root) {
    [].slice.call((root || document).querySelectorAll('.bxp [data-drawer]')).forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function (ev) { ev.preventDefault(); openDrawer(b); });
    });
    var e = drawerEls();
    var cl = document.getElementById('bxp-dclose');
    if (cl && !cl.dataset.bound) { cl.dataset.bound = '1'; cl.addEventListener('click', closeDrawer); }
    if (e.ovl && !e.ovl.dataset.bound) { e.ovl.dataset.bound = '1'; e.ovl.addEventListener('click', closeDrawer); }
  }

  if (!window.__bxpKeys) {
    window.__bxpKeys = true;
    document.addEventListener('keydown', function (e) {
      var dr = document.getElementById('bxp-drawer');
      if (!dr || !dr.classList.contains('on')) return;
      if (e.key === 'Escape') return closeDrawer();
      if (e.key !== 'Tab') return;
      var f = [].slice.call(dr.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function initAll(root) {
    countSetup(root);
    marqueeSetup(root);
    pickerSetup();
    drawerSetup(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  window.addEventListener('resize', function () { marqueeSetup(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
